//enum alternative
export const Status = {
    beginSoon: "beginSoon",

    /**
     * used for webconf when session started by time, but not started by admin
     */
    notStarted: "notStarted",
    started: "started",
    endSoon: "endSoon",
    ended: "ended",
    empty: "empty"
} as const;

export type Status = typeof Status[keyof typeof Status];